import React from "react";
import "./services.css";
import { BiCheck } from "react-icons/bi";

const Services = () => {
  return (
    <section id="services">
      <h5>My experiences</h5>
      <h2>Employment summary</h2>

      <div className="container services__container">
        <article className="service service--modern">
          <div className="service__head service__head--modern">
            <h3>Data Engineer at General Motors</h3>
          </div>
          <ul className="service__list service__list--modern">
            <li>
              <BiCheck className="service__list-icon" />
              <p>Designed and optimized ETL pipelines to process large-scale automotive and security data</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Implemented data integration solutions using Python, SQL, and cloud platforms (AWS/GCP)</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Developed and maintained data models for both relational and NoSQL databases</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Automated data quality checks and monitoring with Airflow and custom scripts</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Collaborated with analysts, engineers, and product teams to deliver actionable insights</p>
            </li>
          </ul>
        </article>
        {/* END OF UI/UX */}
        <article className="service service--modern">
          <div className="service__head service__head--modern">
            <h3>Masters in Artificial Intelligence at Georgia Tech</h3>
          </div>
          <ul className="service__list service__list--modern">
            <li>
              <BiCheck className="service__list-icon" />
              <p>Completed advanced coursework in Machine Learning, Deep Learning, and Natural Language Processing</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Developed hands-on projects in computer vision, reinforcement learning, and generative AI</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Built and contributed to custom open source large language models (LLMs)</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Collaborated with peers on research and industry-focused AI solutions</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Gained proficiency in Python, TensorFlow, PyTorch, and cloud-based ML workflows</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Strengthened problem-solving, innovation, and communication skills through diverse projects</p>
            </li>
          </ul>
        </article>
        {/* WEB DEVELOPMENT */}
        <article className="service service--modern">
          <div className="service__head service__head--modern">
            <h3>Software Engineer at Optimed Health</h3>
          </div>
          <ul className="service__list service__list--modern">
            <li>
              <BiCheck className="service__list-icon" />
              <p>Designed and deployed scalable applications on Google Cloud Platform</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Managed containerized microservices using Kubernetes for robust deployment and orchestration</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Developed modern, responsive user interfaces with React</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Built and maintained backend services in Node.js and Scala</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Worked extensively with relational databases including MySQL for data storage and management</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Collaborated with cross-functional teams to deliver high-quality healthcare solutions</p>
            </li>
          </ul>
        </article>
        {/* END OF CONTENT CREATION */}
      </div>
    </section>
  );
};

export default Services;
